import { render, staticRenderFns } from "./ReferralProgramgbp.vue?vue&type=template&id=7a59df5c&"
import script from "./ReferralProgramgbp.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramgbp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports